import './App.css';
import UnacademyClone from './components/UnacademyClone'

const App = () => (
  <UnacademyClone/>
)

export default App;